<template>
    <div>
      <h2 class="text-1xl font-bold text-gray-700">
        Configuracion de tipo de comprobantes
      </h2>
      <MainTypeOfVouchers />
    </div>
  </template>
  
  <script>
  import MainTypeOfVouchers from "@/components/ConfigurationModules/TypeOfVouchers/MainTypeOfVouchers.vue";
import { useRoute } from 'vue-router';
import { onBeforeMount, onMounted } from 'vue';
import { findSubmoduleIdByDescription } from '@/hisAcces';
  export default {
    name: "TypeOfVouchers",
    components: {
        MainTypeOfVouchers,
    },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
  };
  </script>
  